<template>
    <div class="scc-container scc-container__column scc-container__lg-column--8">
        <div class="scc-content" :class="[`scc-content--${backgroundColor}`]">
            <HeaderElement v-if="showHeader" :breadcrumbs="breadcrumbs" :date="date" />
            <Heading v-if="title && title !== ''" color="primary" tag="h2" class="h3" margin="none" :title="title" />
            <TextElement v-if="subtitle && subtitle !== ''" :text="subtitle" bold class="kwf-menu" />
            <slot></slot>
        </div>
    </div>
</template>

<script>
import './content.scss';

import HeaderElement from '../elements/HeaderElement';
import Heading from './Heading';
import TextElement from '../elements/TextElement';

const backgroundColors = ['primary', 'secondary', 'white', 'grey', 'transparent'];

export default {
    name: 'Content',
    components: { HeaderElement, Heading, TextElement },
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: backgroundColors,
            },
            subtitle: {
                widget: 'textarea',
            },
        },
    },
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return backgroundColors.includes(val);
            },
        },
        showHeader: {
            type: Boolean,
        },
        breadcrumbs: {
            type: String,
        },
        date: String,
        title: String,
        subtitle: String,
    },
};
</script>
